export const DEFAULT_TIME_RANGE = {
    pastDuration: '1h'
};

//# sourceMappingURL=time-range-defaults.js.map